import { useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { useRelayEnvironment } from 'react-relay/hooks';

import { updateFetchKeyDelayed } from '@lib/actions';
import { FetchKeysStoreKey } from '@lib/reducers/createFetchKeysReducer';

import { invalidateStore } from 'services/relayService';

export default function useInvalidateStores() {
  const queryClient = useQueryClient();
  const environment = useRelayEnvironment();
  const dispatch = useDispatch();

  return (keys: Readonly<any[]>, fetchKey?: FetchKeysStoreKey) => {
    // Invalidate react-query
    queryClient.invalidateQueries(keys);

    // Invalidate GQL
    invalidateStore(environment);

    // Force refetch for queries listening to the fetchKey
    if (fetchKey) {
      dispatch(updateFetchKeyDelayed(fetchKey));
    }

    // TODO how to invalidate redux store?

    // We might want to do that using a saga listening to those fetchKeys, but not sure if that'd break lookups
    // Eg we've an appointment normalized and stored on the redux store, what happens with the `Appontment.patient`
    // if we cleanup the `normalizr.entities.patient` store?
  };
}
